import script from "./ManagementPlanDiagnosesGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./ManagementPlanDiagnosesGroup.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__